import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

export const BRAND = {
  name: "Random Cam Chat",
  tagline: "Meet new people. One random video chat at a time.",
  logo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_video-connect-168/artifacts/0r16ik77_322186431_1367377040670083_1391729757813206098_n.jpg",
};

export function wsUrl(token) {
  const base = BACKEND_URL.replace(/^http/, "ws");
  return `${base}/api/ws?token=${encodeURIComponent(token)}`;
}
